import React from 'react';
import { ArrowUp, Github, Linkedin, Mail } from 'lucide-react';
import { portfolioData } from '../mock';

const Footer = () => {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[hsl(var(--rule))] px-5 sm:px-8 lg:px-12 py-12"
    >
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-12 gap-10 mb-10">
          <div className="md:col-span-6 space-y-4">
            <div className="mono text-sm">
              <span className="text-[hsl(var(--foreground-faint))]">~/</span>
              <span>{portfolioData.personal.name.toLowerCase().split(' ').join('-')}</span>
              <span className="caret text-[hsl(var(--accent))]" />
            </div>
            <p className="text-[hsl(var(--foreground-muted))] max-w-md leading-relaxed">
              Developer working on language models, research tooling, and the kind of small details that decide whether a system holds up in production.
            </p>
          </div>

          <div className="md:col-span-3 space-y-4">
            <div className="mono text-[0.7rem] uppercase tracking-wider text-[hsl(var(--foreground-faint))]">
              navigate
            </div>
            <ul className="space-y-2">
              {[
                { label: 'about', id: 'about' },
                { label: 'experience', id: 'experience' },
                { label: 'writing', id: 'publications' },
                { label: 'contact', id: 'contact' },
              ].map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={`footer-nav-${l.id}`}
                    onClick={() =>
                      document.getElementById(l.id)?.scrollIntoView({ behavior: 'smooth' })
                    }
                    className="mono text-sm text-[hsl(var(--foreground-muted))] hover:text-[hsl(var(--accent))] transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3 space-y-4">
            <div className="mono text-[0.7rem] uppercase tracking-wider text-[hsl(var(--foreground-faint))]">
              elsewhere
            </div>
            <ul className="space-y-2">
              <li>
                <a
                  data-testid="footer-github"
                  href={portfolioData.personal.github}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mono text-sm text-[hsl(var(--foreground-muted))] hover:text-[hsl(var(--accent))] transition-colors inline-flex items-center gap-2"
                >
                  <Github className="w-3.5 h-3.5" /> github
                </a>
              </li>
              <li>
                <a
                  data-testid="footer-linkedin"
                  href={portfolioData.personal.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mono text-sm text-[hsl(var(--foreground-muted))] hover:text-[hsl(var(--accent))] transition-colors inline-flex items-center gap-2"
                >
                  <Linkedin className="w-3.5 h-3.5" /> linkedin
                </a>
              </li>
              <li>
                <a
                  data-testid="footer-email"
                  href={`mailto:${portfolioData.personal.email}`}
                  className="mono text-sm text-[hsl(var(--foreground-muted))] hover:text-[hsl(var(--accent))] transition-colors inline-flex items-center gap-2"
                >
                  <Mail className="w-3.5 h-3.5" /> email
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-[hsl(var(--rule))] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="mono text-xs text-[hsl(var(--foreground-faint))]">
            © {year} {portfolioData.personal.name}. crafted with care.
          </div>
          <button
            data-testid="back-to-top"
            onClick={scrollTop}
            className="mono text-xs text-[hsl(var(--foreground-muted))] hover:text-[hsl(var(--accent))] transition-colors inline-flex items-center gap-2 group"
          >
            <span>back to top</span>
            <ArrowUp className="w-3 h-3 group-hover:-translate-y-0.5 transition-transform" />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
